import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: inherit;
	flex: 1;
	&.empty {
		justify-content: center;
	}

	rect {
		&.highcharts-background {
			fill: transparent;
		}
		&.highcharts-point {
			stroke: var(--neutrals-25);
		}
	}
	section.notes-status {
		width: var(--px-80);
	}
`;
